import { useState, useEffect } from 'react';

const sfxKey = "tv_sfx_enabled";

// Confete simples via canvas (sem libs externas)
function fireConfetti() {
  const c = document.createElement("canvas");
  c.style.position = "fixed";
  c.style.inset = "0";
  c.style.pointerEvents = "none";
  c.style.zIndex = "9999";
  document.body.appendChild(c);
  
  const ctx = c.getContext("2d")!;
  const W = c.width = window.innerWidth;
  const H = c.height = window.innerHeight;
  
  const parts = Array.from({length: 80}, () => ({
    x: Math.random() * W,
    y: -20 - Math.random() * 50,
    r: 4 + Math.random() * 6,
    vy: 2 + Math.random() * 4,
    vx: -2 + Math.random() * 4
  }));
  
  let t = 0;
  (function anim() {
    t++;
    ctx.clearRect(0, 0, W, H);
    parts.forEach(p => {
      p.y += p.vy;
      p.x += p.vx;
      ctx.fillStyle = `hsl(${(t + p.x) % 360} 90% 60%)`;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    });
    if (t < 45) requestAnimationFrame(anim);
    else document.body.removeChild(c);
  })();
}

// Mini cache anti-spam geral
let last = 0;
const canPlay = (ms = 1500) => {
  const now = Date.now();
  if (now - last > ms) {
    last = now;
    return true;
  }
  return false;
};

function play(url: string, vol = 0.6) {
  try {
    const a = new Audio(url);
    a.volume = vol;
    a.play().catch(() => {});
  } catch {}
}

export function useCelebrations() {
  const [enabled, setEnabled] = useState(() => {
    if (typeof window === 'undefined') return true;
    return localStorage.getItem(sfxKey) !== 'false';
  });

  const setSfxEnabled = (value: boolean) => {
    setEnabled(value);
    localStorage.setItem(sfxKey, String(value));
  };

  // Suporte a URL param ?sound=off
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('sound') === 'off') {
      setSfxEnabled(false);
    }
  }, []);

  const closed = () => {
    if (!canPlay()) return;
    if (enabled) play("/sfx/success.mp3", 0.6);
    fireConfetti();
  };

  const canceled = () => {
    if (!canPlay()) return;
    if (enabled) play("/sfx/warn.mp3", 0.4);
    document.documentElement.classList.add("tv-shake");
    setTimeout(() => document.documentElement.classList.remove("tv-shake"), 500);
  };

  const goal = () => {
    if (!canPlay()) return;
    if (enabled) play("/sfx/success.mp3", 0.6);
    fireConfetti();
  };

  const sla = () => {
    if (!canPlay()) return;
    if (enabled) play("/sfx/warn.mp3", 0.3);
  };

  const notification = () => {
    if (!canPlay(2000)) return; // Anti-spam de 2 segundos
    if (enabled) play("/sfx/warn.mp3", 0.5);
  };

  return {
    closed,
    canceled,
    goal,
    sla,
    notification,
    sfxEnabled: enabled,
    setSfxEnabled
  };
}

